$eve_app_color $mol_view
	value? \
	attr *
		^
		eve_themer_color \
	sub /
		<= Input $mol_string
			value? <=> value?
		<= Picker_wrapper $mol_view
			sub /
				<= Picker $mol_view
					attr *
						type \color
					dom_name \input
					event *
						input? <=> picker_input? null
